<template>
  <navbar class="action-bar">
    <template slot="collapse-btn"><span></span></template>
    <ul class="nav nav-pills">
      <li v-for="(a, i) in list"
          v-if="a.nav()"
          :class="{ success: a.success(), disabled: a.disabled() || a.active(), active: a.active()}"
          :key="`${uid}-${i}`">
        <a role="button"
           class="action-bar-button"
           @click.stop="call(a)"
           v-tooltip.unenterable="a.tooltip">
          <span class="glyphicon"
                :class="`glyphicon-${a.icon}`"
                aria-hidden="true">
          </span>
          <span class="hidden-xs hidden-sm">{{ a.text }}</span>
        </a>
      </li>
    </ul>
  </navbar>
</template>
<script>

const impl = {
  tooltip: function (t) {
    if (t == null) {
      return ''
    }

    const tooltip = t.tooltip ? t.tooltip() : t.text

    return `<span class="hint-tooltip">${tooltip}<br />${t.keyText}</span>`
  }
}

export default {
  name: 'action-bar',

  props: {
    actions: {
      type: Array,
      required: true
    }
  },

  methods: {
    call: function (a) {
      if (a.disabled == null || !a.disabled()) {
        a.action(a.param)
      }
    }
  },

  computed: {
    list: function () {
      const result = []
      const c = ['disabled', 'success', 'active', 'nav']

      for (let i in this.actions) {
        const a = this.actions[i]
        const item = {
          action: a.action,
          param: a.param,
          right: a.right,
          tooltip: impl.tooltip(a),
          icon: a.icon,
          text: a.text,
          nav: () => a.nav && a.nav()
        }
        c.forEach(t => { item[t] = () => a[t] && a[t]() })

        result.push(item)
      }
      return result
    },

    uid: function () {
      return `action-bar-${this._uid}`
    }
  }
}
</script>
<style lang="less">
@import '~variables';
.action-bar {
  padding-top: 0.8rem;
  li.disabled {
    opacity: 0.3;
    a {
      background-color:  @base;
      color: white;
      border: 1px solid @base;
    }

    a:hover {
      background-color:  @base;
      color: white;
      border-color: @darker-base;
    }
  }

  li {
    a {
      background-color:  @base;
      color: white;
      border: 1px solid @base;
    }

    a:hover {
      background-color:  @darker-base;
      border-color: @darker-base;
    }
  }

  li.success.disabled {
    a {
      background-color: @brand-success;
      border: 1px solid @brand-success;
    }

    a:hover {
      background-color: @brand-success;
    }
  }

  li.success {
    a {
      background-color: @brand-success;
      border: 1px solid @brand-success;
    }

    a:hover {
      background-color: darken(@brand-success, 20%);
      border-color: darken(@brand-success, 20%);
    }
  }
}
</style>
<style scoped lang="less">
@import '~variables';
.action-bar {
  margin-bottom: 0px;
  border-radius: 0px;
  border-top: 0px;
  border-bottom: 0px;
  border-left: 0px;

  li.active {
    opacity: 1;
    a {
      background-color: @darker-base;
      border: 1px solid @darker-base;
    }
  }

  li.active.success {
    a {
      background-color: darken(@brand-success, 20%);
      border: 1px solid darken(@brand-success, 20%);
    }
  }
}

.action-bar-button {
  padding: 6px 12px;
  .glyphicon {
    font-size: 100%;
    margin-right: 0.4rem;
  }
  font-size: 100%;
}
</style>
